import { Layout, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { toggleCollapsedSideNav } from '../../appRedux/actions';
import UserInfo from '../../components/layout/UserInfo';
import { NAV_STYLE_DRAWER, NAV_STYLE_FIXED, NAV_STYLE_MINI_SIDEBAR, TAB_SIZE } from '../../constants/ThemeSetting';
import Auxiliary from '../../util/Auxiliary';
import { Typewriter } from 'react-simple-typewriter';
import { useEffect, useState } from 'react';
import { fetchHistoryChats, historyChatsReset } from '../../redux/chatApp/HistoryChat';

const { Header } = Layout;

const Topbar = () => {
	const { navStyle } = useSelector(({ settings }: any) => settings);
	const navCollapsed = useSelector(({ common }: any) => common.navCollapsed);
	const width = useSelector(({ common }: any) => common.width);
	const dispatch = useDispatch();


	return (
		<Header
			className=" gx-px-2 "
			style={{
				// background: "linear-gradient(315deg, #ffffff 0%, #91a6ff 84%)"
				// background: 'linear-gradient(315deg,rgb(170, 185, 253) 2% 0%,#ffffff )',
				backgroundColor:"#1E1D24",
				marginLeft:"-1px !important",
				overflow: 'hidden'
			}}
		>
			<div className="stars"></div>
			<div className="stars2"></div>
			<div className="stars3"></div>

			<div className="moving-bubble1"></div>

			{navStyle === NAV_STYLE_DRAWER || ((navStyle === NAV_STYLE_FIXED || navStyle === NAV_STYLE_MINI_SIDEBAR) && width < TAB_SIZE) ? (
				<div className="gx-linebar gx-mr-3 gx-d-flex gx-align-items-center gx-justify-content-between" style={{ width: '100%' }}>
					<div className="gx-d-flex gx-align-items-center">
						<i
							className="gx-icon-btn icon icon-menu"
							onClick={() => {
								dispatch(toggleCollapsedSideNav(!navCollapsed));
							}}
						/>

						<img src="/assets/images/logo.png" alt="Avatar" width={62} />
					</div>

					<div>
						<p className="gx-m-0 gx-p-0  gx-fs-xs" style={{ fontFamily: 'NoirPro', color: 'green' }}>
							{/* <Typewriter
											words={['Chat effortlessly with your bot']}
											typeSpeed={30}
											cursor={true}
											loop={true}
											
										/> */}
							<p className="gx-user-nav gx-mr-2 gx-mt-0 gx-p-0 gx-m-0">
								<UserInfo />
							</p>
						</p>
					</div>
				</div>
			) : null}
			{/* <Link to="/realtimedashboard" className="gx-d-block gx-d-lg-none gx-pointer">
			<CardHeader
                  icon={
                    newAlertTriggered ? (
                      <Tooltip
                        title={
                          "A new alert has triggered, click to retrieve the most recent data."
                        }
                      >
                        <Badge
                          count={alertTriggerCount}
                          size="small"
                          offset={[5, 0]}
                        >
                          <BellOutlined
                            className="bell-icon"
                            style={{
                              color: "#F5222D",
                              cursor: "pointer",
                              fontSize: "20px",
                            }}
                           // onClick={handleGetRealTimeData}
                          />
                        </Badge>{" "}
                        &nbsp;
                      </Tooltip>
                    ) : (
                      <HiMiniBellAlert style={{ fontSize: "20px" }} />
                    )
                  }
                  title={"ALERTS"}
                />
		</Link> */}

			{/* <SearchBox styleName="gx-d-none gx-d-lg-block gx-lt-icon-search-bar-lg"
        placeholder="Search in app..."
        onChange={updateSearchChatUser}
        value={searchText} /> */}

			{/* <AppsNavigation />  */}
			{width > TAB_SIZE && (
				<ul className="gx-header-notifications" style={{ width: '100%' }}>
					<Auxiliary>
						<div className="" style={{ width: '100%' }}>
							<span className="gx-d-block gx-d-lg-none gx-chat-btn">{/* <i className="gx-icon-btn icon icon-chat"></i> */}</span>
							<div className="gx-chat-main-header-info gx-d-flex gx-justify-content-between gx-px-0 gx-py-2" style={{ width: '100%' }}>
								<div className="gx-d-flex ">
									{/* <div className="gx-chat-avatar">
										<div className="gx-status-pos">
											<span className="gx-status"></span>
											<span
												className="gx-size-40 gx-ml-1 "
											
											>
												<img src="/assets/images/p-sales-ai-white.svg" alt="Avatar" width={150}/>
											</span>
										</div>
									</div> */}

									<div className="gx-fs-sm gx-mt-1">
										{/* <p
											className="gx-p-0 gx-m-0 gx-link gx-p-0 gx-fs-sm chathead"
											style={{ textDecoration: 'underline', fontFamily: 'NoirPro', fontWeight: 500 }}
										>
											PSSPL - <span className="gx-font-weight-light gx-fs-xs gx-p-0 gx-m-0 gx-ml-1">(Chat BOT) </span>{' '}
										</p> */}
										{/* <p className="gx-m-0 gx-p-0 gx-mb-2  chatdes gx-fs-xs" style={{ fontFamily: 'NoirPro', color: 'green' }}>
											<Typewriter
												words={['Chat effortlessly with your bot using text or voice—your smart assistant, anytime, anywhere!']}
												typeSpeed={30}
												cursor={true}
												loop={true}
											/>
										</p> */}
									</div>
								</div>

								{/* <div>
                                    <img
                                        src="/assets/images/logo.png"
                                        width={70}
                                        alt="Avatar"
                                        style={{
                                            filter: 'hue-rotate(600deg) saturate(200%) brightness(1.6)'
                                        }}
                                    />
                                </div> */}
								<li className="gx-user-nav gx-mr-2">
									<UserInfo />{' '}
								</li>
							</div>
						</div>
					</Auxiliary>
				</ul>
			)}

			{/* <ul className="gx-header-notifications gx-ml-auto">
			

					<Auxiliary>
						<li className="gx-user-nav">
							<UserInfo />{' '}
						</li>
					</Auxiliary>
				</ul> */}
		</Header>
	);
};

export default Topbar;
